"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockStatement = ({ ast, execObject }) => {
    return ast.children.rules.reduce((ac, line) => {
        return execObject.interpreter({ ast: line.children.rules[0], execObject });
    }, {});
};
